import { useEffect, useState } from "react";
import { db } from "../services/firebase";
import { ref, onValue } from "firebase/database";
import { useNavigate } from "react-router-dom";

export default function Dashboard() {
  const navigate = useNavigate();

  const [teachers, setTeachers] = useState(0);
  const [subjects, setSubjects] = useState(0);
  const [classes, setClasses] = useState(0);
  const [arrangements, setArrangements] = useState(0);
  const [presentTeachers, setPresentTeachers] = useState(0);
  const [absentTeachers, setAbsentTeachers] = useState(0);
  const [onDutyTeachers, setOnDutyTeachers] = useState(0);
  const [todayArrangements, setTodayArrangements] = useState(0);

  const today = new Date().toISOString().split('T')[0];

  useEffect(() => {
    const listeners = [
      { path: "teachers", setter: setTeachers },
      { path: "subjects", setter: setSubjects },
      { path: "classes", setter: setClasses },
    ];

    listeners.forEach(({ path, setter }) => {
      onValue(ref(db, path), (snapshot) => {
        const data = snapshot.val();
        setter(data ? Object.keys(data).length : 0);
      });
    });

    // Load teacher status for today
    onValue(ref(db, `teacherStatus/${today}`), (snapshot) => {
      const data = snapshot.val() || {};
      let present = 0, absent = 0, onDuty = 0;
      Object.values(data).forEach((status) => {
        if (status.status === 'Present') present++;
        else if (status.status === 'Absent') absent++;
        else if (status.status === 'On Duty') onDuty++;
      });
      setPresentTeachers(present);
      setAbsentTeachers(absent);
      setOnDutyTeachers(onDuty);
    });

    // Load arrangements for today
    onValue(ref(db, `arrangements/${today}`), (snapshot) => {
      const data = snapshot.val();
      setTodayArrangements(data ? data.length : 0);
      setArrangements(data ? data.length : 0);
    });
  }, [today]);

  // Handle logout
  const handleLogout = () => {
    localStorage.removeItem('isLoggedIn');
    localStorage.removeItem('rememberMe');
    navigate('/login');
  };

  const cards = [
    {
      title: "Teachers",
      value: teachers,
      color: "#2563eb",
      page: "/teachers",
    },
    {
      title: "Subjects",
      value: subjects,
      color: "#16a34a",
      page: "/subjects",
    },
    {
      title: "Classes",
      value: classes,
      color: "#f59e0b",
      page: "/classes",
    },
    {
      title: "Arrangements",
      value: arrangements,
      color: "#dc2626",
      page: "/teacher-arrangement",
    },
  ];

  const buttonStyle = {
    padding: "14px",
    border: "none",
    borderRadius: "10px",
    background: "#2563eb",
    color: "#fff",
    fontWeight: "bold",
    cursor: "pointer",
    transition: "all 0.2s",
  };

  return (
    <div style={{ padding: 15, background: "#f4f6f9", minHeight: "100vh" }}>
      {/* Header with Logout Button */}
      <div style={{ 
        display: "flex", 
        justifyContent: "space-between", 
        alignItems: "center",
        flexWrap: "wrap",
        gap: "10px"
      }}>
        <div>
          <h2 style={{ marginBottom: 5 }}>School Timetable Dashboard</h2>
          <p style={{ color: "#666" }}>
            Manage Teachers, Subjects, Classes & Timetables
          </p>
        </div>
        <button
          onClick={handleLogout}
          style={{
            padding: "10px 20px",
            backgroundColor: "#dc2626",
            color: "white",
            border: "none",
            borderRadius: "8px",
            fontSize: "14px",
            fontWeight: "600",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            gap: "8px",
            transition: "all 0.3s ease",
          }}
          onMouseEnter={(e) => e.target.style.backgroundColor = "#b91c1c"}
          onMouseLeave={(e) => e.target.style.backgroundColor = "#dc2626"}
        >
          <span>🚪</span> Logout
        </button>
      </div>

      {/* Statistics */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit,minmax(160px,1fr))",
          gap: 15,
          marginTop: 20,
        }}
      >
        {cards.map((card) => (
          <div
            key={card.title}
            onClick={() => navigate(card.page)}
            style={{
              background: "#fff",
              borderRadius: 12,
              padding: 20,
              cursor: "pointer",
              borderLeft: `6px solid ${card.color}`,
              boxShadow: "0 2px 8px rgba(0,0,0,.08)",
            }}
          >
            <h4>{card.title}</h4>
            <h1 style={{ color: card.color, marginTop: 10 }}>
              {card.value}
            </h1>
          </div>
        ))}
      </div>

      {/* Today's Status Cards */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit,minmax(200px,1fr))",
          gap: 15,
          marginTop: 20,
        }}
      >
        <div
          style={{
            background: "#fff",
            borderRadius: 12,
            padding: 20,
            borderLeft: "6px solid #22c55e",
            boxShadow: "0 2px 8px rgba(0,0,0,.08)",
          }}
        >
          <h4 style={{ color: "#666" }}>✅ Present Teachers</h4>
          <h1 style={{ color: "#22c55e", marginTop: 10 }}>{presentTeachers}</h1>
        </div>
        <div
          style={{
            background: "#fff",
            borderRadius: 12,
            padding: 20,
            borderLeft: "6px solid #ef4444",
            boxShadow: "0 2px 8px rgba(0,0,0,.08)",
          }}
        >
          <h4 style={{ color: "#666" }}>❌ Absent Teachers</h4>
          <h1 style={{ color: "#ef4444", marginTop: 10 }}>{absentTeachers}</h1>
        </div>
        <div
          style={{
            background: "#fff",
            borderRadius: 12,
            padding: 20,
            borderLeft: "6px solid #f59e0b",
            boxShadow: "0 2px 8px rgba(0,0,0,.08)",
          }}
        >
          <h4 style={{ color: "#666" }}>📋 On Duty Teachers</h4>
          <h1 style={{ color: "#f59e0b", marginTop: 10 }}>{onDutyTeachers}</h1>
        </div>
        <div
          style={{
            background: "#fff",
            borderRadius: 12,
            padding: 20,
            borderLeft: "6px solid #8b5cf6",
            boxShadow: "0 2px 8px rgba(0,0,0,.08)",
          }}
        >
          <h4 style={{ color: "#666" }}>📊 Today's Arrangements</h4>
          <h1 style={{ color: "#8b5cf6", marginTop: 10 }}>{todayArrangements}</h1>
        </div>
      </div>

      {/* Quick Actions */}
      <div
        style={{
          background: "#fff",
          marginTop: 25,
          borderRadius: 12,
          padding: 20,
        }}
      >
        <h3>Quick Actions</h3>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(2,1fr)",
            gap: 12,
            marginTop: 15,
          }}
        >
          <button 
            style={buttonStyle} 
            onClick={() => navigate("/subjects")}
          >
            📚 Add Subject
          </button>
          <button 
            style={{...buttonStyle, background: "#16a34a"}} 
            onClick={() => navigate("/teachers")}
          >
            👨‍🏫 Add Teacher
          </button>
          <button 
            style={{...buttonStyle, background: "#f59e0b"}} 
            onClick={() => navigate("/classes")}
          >
            🏫 Add Class
          </button>
          <button 
            style={{...buttonStyle, background: "#8b5cf6"}} 
            onClick={() => navigate("/timetable")}
          >
            📅 Timetable Editor
          </button>
          <button
            style={{
              ...buttonStyle,
              background: "#dc2626",
              gridColumn: "1 / span 2",
            }}
            onClick={() => navigate("/teacher-arrangement")}
          >
            👨‍🏫 Teacher Arrangement & Substitution
          </button>
          <button
            style={{
              ...buttonStyle,
              background: "#0891b2",
              gridColumn: "1 / span 2",
            }}
            onClick={() => navigate("/arrangement-history")}
          >
            📊 Arrangement History & Reports
          </button>
        </div>
      </div>

      {/* Recent Activity */}
      <div
        style={{
          background: "#fff",
          marginTop: 25,
          borderRadius: 12,
          padding: 20,
        }}
      >
        <h3>Recent Activity</h3>
        <ul style={{ color: "#666", lineHeight: "2" }}>
          <li>📅 Today's arrangements: {todayArrangements}</li>
          <li>👨‍🏫 Present teachers: {presentTeachers}</li>
          <li>❌ Absent teachers: {absentTeachers}</li>
          <li>📋 On duty teachers: {onDutyTeachers}</li>
        </ul>
      </div>

      {/* Footer */}
      <div
        style={{
          textAlign: "center",
          marginTop: 40,
          color: "#888",
          fontSize: 13,
        }}
      >
        School Timetable & Arrangement Management System
      </div>
    </div>
  );
}